import React, { useContext, useEffect, useState } from "react";
import WorkTimeSettingComponent from "../../Common/settingComponet/WorkTimeSettingComponent";
import { UsedCarSettingContext } from "./UsedCarSettingIndex";
import TimeSlotComponent from "../../Common/settingComponet/TimeSlotComponent";
import { useSelector } from "react-redux";
import { compareTwoDate, convertToUTCDate } from "../../../utility/utils";

export default function TimeView() {
  const {
    compareMonthAndYear,
    selectedCar,
    workingDayTime,
    selectedCars,
    currentMonth,
    handleMonthDateUpdate,
    workingTime,
    setWorkingDayTime,
    dateValue,
    usedCars,
    handleSingleUpdate,
  } = useContext(UsedCarSettingContext);
  const { usedCarSettingInfo } = useSelector((state) => state.usedCars);
  const [workingTimeSlots, setWorkingTimeSlots] = useState([]);

  useEffect(() => {
    try {
      if (Object.keys(workingTime).length !== 0) {
        let currentTime = workingTime.start;
        let endTime = workingTime.end;
        let startDate = new Date();
        let endDate = new Date();
        let [startHour, startMinute] = currentTime.split(":");
        startDate.setHours(startHour, startMinute, 0, 0);

        let [endStartHour, endStartMinute] = endTime.split(":");
        endDate.setHours(endStartHour, endStartMinute - 15, 0, 0);

        const allTime = [];

        while (startDate < endDate) {
          startDate.setMinutes(startDate.getMinutes() + 15);
          const tempTime = startDate.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });

          allTime.push({
            time: tempTime,
            status: false,
          });
        }
        setWorkingTimeSlots(allTime);
      }
    } catch (error) {
      console.log(error);
    }
  }, [workingTime]);

  useEffect(() => {
    try {
      if (
        selectedCars.length > 0 &&
        usedCarSettingInfo?.length > 0 &&
        workingTimeSlots.length > 0
      ) {
        // const exist = usedCarSettingInfo[0]; // Assuming you want to fetch data for the first used car

        const usedCarSettingInfoFiltered = usedCarSettingInfo?.filter((ele) => {
          if (selectedCars.includes(ele.car)) {
            return ele;
          }
        });
        if (usedCarSettingInfoFiltered.length > 0) {
          const monthUCsetting =
            usedCarSettingInfoFiltered[0]?.usedCarMonthSetting.find(
              ({ monthYearDate }) =>
                compareMonthAndYear(monthYearDate, currentMonth)
            );
          if (monthUCsetting) {
            const dateData = monthUCsetting?.usedCarDateSettings.find(
              ({ date }) => compareTwoDate(date, dateValue)
            );

            // workingDayTime?;
            console.log(dateData);
            
            
            if (dateData?.timeSlots?.length > 0) {
              setWorkingDayTime(dateData?.timeSlots);
            } else {
              setWorkingDayTime(workingTimeSlots);
            }
          }
        }
      } else {
        setWorkingDayTime(workingTimeSlots);
      }
    } catch (error) {
      console.log(error);
    }
  }, [usedCarSettingInfo, selectedCars, workingTimeSlots,dateValue]);

  return (
    <div className="flex flex-col gap-5 no-scrollbar">
      <WorkTimeSettingComponent
        SettingContextData={useContext(UsedCarSettingContext)}
        handleMonthDateUpdate={async () => {
          await handleMonthDateUpdate({
            usedCars: selectedCars,
            monthYearDate: convertToUTCDate(currentMonth),
            workingTime,
          });
        }}
      />
      <TimeSlotComponent
        SettingContextData={useContext(UsedCarSettingContext)}
        handleSingleUpdate={async () =>
          await handleSingleUpdate({
            usedCars: selectedCars,
            workingDayTime,
            currentDate: convertToUTCDate(dateValue),
            monthYearDate: convertToUTCDate(currentMonth),
          })
        }
        handleMonthDateUpdate={async () =>
          await handleMonthDateUpdate({
            usedCars: selectedCars,
            monthYearDate: convertToUTCDate(currentMonth),
            workingDayTime,
          })
        }
        selectedCars={selectedCars}
        usedCarSettingInfo={usedCarSettingInfo}
        usedCars={usedCars}
        type="usedCarsSettings"
      />
    </div>
  );
}
